import gql from 'graphql-tag';

import type { PageInfoResponse } from 'common/graphql/fragments/PageInfo';
import type { AccountKind } from 'common/types/accountKind';

import type { EventKind } from './EventKind';

export const NotificationFragment = gql`
  fragment Notification on Notification {
    id
    severity
    message
    args
    acknowledged
    toast
    insertedAt
    updatedAt
    actionable
    kind

    account {
      id
      name
      kind
    }
    organization {
      id
      name
    }
    customer {
      id
      name
    }
  }
`;

export type NotificationEntityDetails = {
  id: string;
  name: string;
};

export enum NotificationSeverity {
  WARNING = 'WARNING',
  INFO = 'INFO',
  ERROR = 'ERROR',
}

export type NotificationResponse = {
  id: string;
  severity: NotificationSeverity;
  message: string;
  args: string; // JSON encoded as string
  acknowledged: boolean;
  actionable: boolean;
  toast: boolean;
  account?: NotificationEntityDetails & { kind?: AccountKind };
  organization?: NotificationEntityDetails;
  customer?: NotificationEntityDetails;
  insertedAt: string;
  updatedAt: string;
  kind: EventKind;
};

export type PaginatedNotificationsResponse = {
  owner: {
    id: string;
    notificationsPaginated: {
      notifications: NotificationResponse[];
      pageInfo: PageInfoResponse;
    };
  };
};
